import * as React from "react";
import { useState } from "react";
import PropTypes from "prop-types";
import {
  CircularProgress,
  Grid,
  Pagination,
  PaginationItem,
  useMediaQuery,
} from "@mui/material";
import Skeleton from "@mui/material/Skeleton";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardDoubleArrowLeftRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowLeftRounded";
import KeyboardDoubleArrowRightRoundedIcon from "@mui/icons-material/KeyboardDoubleArrowRightRounded";
import EditRoundedIcon from "@mui/icons-material/EditRounded";
import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import CloseRoundedIcon from "@mui/icons-material/CloseRounded";

import { useNavigate } from "react-router-dom";
import "./TableBenefitReceiving.css";

function normalizeBool(v) {
  return v === true || v === "true" || v === "Y" || v === "y";
}

function RenderRow({ row, index, isMobile }) {
  const navigate = useNavigate();
  const [open, setOpen] = React.useState(false);

  const isUnder7 = row.age_range === "MST009";
  const isUnder20 = row.age_range === "MST010";

  const safeFiles = Array.isArray(row.file) ? row.file : [];

  const getImage = (row, idx) => {
    const docCodeToCheck = `${row.age_range}_${idx}`;
    const matchingFile = safeFiles.find(
      (file) => file.doc_code === docCodeToCheck
    );
    return matchingFile ? matchingFile.file_name : row.imageOwner || "-";
  };

  return (
    <React.Fragment>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" }, backgroundColor: "white" }}
      >
        <TableCell component="th" scope="row" align="center">
          {index + 1}
        </TableCell>
        <TableCell>{`${row.cus_nm} ${row.cus_ln}`}</TableCell>
        <TableCell>{row.cus_psnid}</TableCell>

        {!isMobile ? <TableCell>{row.cus_tel}</TableCell> : null}

        <TableCell>
          {normalizeBool(row.cus_check) ? (
            <CheckRoundedIcon style={{ color: "green" }} />
          ) : (
            <CloseRoundedIcon style={{ color: "red" }} />
          )}
        </TableCell>

        {!isMobile ? <TableCell>{row.create_date}</TableCell> : null}

        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
      </TableRow>

      <TableRow>
        <TableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            backgroundColor: "#cdcbcb33",
          }}
          colSpan={isMobile ? 5 : 7}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ m: 1, p: "16px", maxWidth: "80vw" }} component={Paper}>
              <Grid container spacing={1}>
                {isMobile ? (
                  <>
                    <Grid item xs={4}>
                      <span className="bold">{"เบอร์โทร"}</span>
                    </Grid>
                    <Grid item xs={8}>
                      <span>{row.cus_tel || "-"}</span>
                    </Grid>
                    <Grid item xs={4}>
                      <span className="bold">{"วันที่ลูกค้าทำรายการ"}</span>
                    </Grid>
                    <Grid item xs={8}>
                      <span>{row.create_date || "-"}</span>
                    </Grid>
                  </>
                ) : null}

                <Grid item xs={4}>
                  <span className="bold">{"ธนาคาร"}</span>
                </Grid>
                <Grid item xs={8}>
                  <span>{row.cuscf_bank || "-"}</span>
                </Grid>

                <Grid item xs={4}>
                  <span className="bold">
                    {row.cuscf_bank === "PromptPay"
                      ? "เลขที่พร้อมเพย์"
                      : "เลขบัญชี"}
                  </span>
                </Grid>
                <Grid item xs={8}>
                  {row.cuscf_bank === "PromptPay" ? (
                    <span>{row.cus_psnid || "-"}</span>
                  ) : (
                    <span>{row.cuscf_banknum || "-"}</span>
                  )}
                </Grid>

                <Grid item xs={4}>
                  <span className="bold">{"KYC "}</span>
                </Grid>
                <Grid item xs={8}>
                  <span>{row.cus_kyc || "-"}</span>
                </Grid>

                <Grid item xs={12} sm={8} md={7} lg={6}>
                  <span className="bold">
                    {isUnder7
                      ? "สำเนาสูติบัตรของผู้เยาว์ เซ็นสำเนาถูกต้อง  "
                      : isUnder20
                      ? "สำเนาบัตรประชาชนของผู้เยาว์ เซ็นสำเนาถูกต้อง  "
                      : "สำเนาบัตรประชาชน เซ็นสำเนาถูกต้อง  "}
                  </span>
                </Grid>
                <Grid item xs={12} sm={4} md={5} lg={6}>
                  <a
                    className="text-orange text-long-hidden"
                    href={
                      safeFiles.find((f) => f.doc_code === `${row.age_range}_1`)
                        ?.link_files || "#"
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {getImage(row, 1)}
                  </a>
                </Grid>

                <Grid item xs={12} sm={8} md={7} lg={6}>
                  <span className="bold">
                    {isUnder7
                      ? "รูปถ่ายหน้าตรงที่เป็นปัจจุบันของผู้เยาว์ "
                      : isUnder20
                      ? "รูปถ่ายหน้าตรงคู่กับบัตรประชาชนของผู้เยาว์"
                      : "รูปถ่ายหน้าตรงคู่กับบัตรประชาชน"}
                  </span>
                </Grid>
                <Grid item xs={12} sm={4} md={5} lg={6}>
                  <a
                    className="text-orange text-long-hidden"
                    href={
                      isUnder7
                        ? safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_4`
                          )?.link_files
                        : isUnder20
                        ? safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_3`
                          )?.link_files
                        : safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_2`
                          )?.link_files
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {isUnder7
                      ? getImage(row, 4)
                      : isUnder20
                      ? getImage(row, 3)
                      : getImage(row, 2)}
                  </a>
                </Grid>

                {isUnder7 || isUnder20 ? (
                  <>
                    <Grid item xs={12} sm={8} md={7} lg={6}>
                      <span className="bold">
                        {
                          "สำเนาบัตรประชาชนของผู้ปกครอง โดยชอบธรรม เซ็นสำเนาถูกต้อง "
                        }
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4} md={5} lg={6}>
                      <a
                        className="text-orange text-long-hidden"
                        href={
                          safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_2`
                          )?.link_files || "#"
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getImage(row, 2)}
                      </a>
                    </Grid>

                    <Grid item xs={12} sm={8} md={7} lg={6}>
                      <span className="bold">
                        {
                          "รูปถ่ายหน้าตรงคู่กับบัตรประชาชนของผู้ปกครองโดยชอบธรรม "
                        }
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4} md={5} lg={6}>
                      <a
                        className="text-orange text-long-hidden"
                        href={
                          isUnder7
                            ? safeFiles.find(
                                (f) => f.doc_code === `${row.age_range}_3`
                              )?.link_files
                            : safeFiles.find(
                                (f) => f.doc_code === `${row.age_range}_4`
                              )?.link_files
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {isUnder7 ? getImage(row, 3) : getImage(row, 4)}
                      </a>
                    </Grid>

                    <Grid item xs={12} sm={8} md={7} lg={6}>
                      <span className="bold">
                        {"สำเนาทะเบียนบ้านของผู้เยาว์ เซ็นสำเนาถูกต้อง "}
                      </span>
                    </Grid>
                    <Grid item xs={12} sm={4} md={5} lg={6}>
                      <a
                        className="text-orange text-long-hidden"
                        href={
                          safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_6`
                          )?.link_files
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {getImage(row, 6)}
                      </a>
                    </Grid>
                  </>
                ) : null}

                <Grid item xs={12} sm={8} md={7} lg={6}>
                  <span className="bold">{"สำเนาสมุดบัญชีเงินฝากธนาคาร "}</span>
                </Grid>
                <Grid item xs={12} sm={4} md={5} lg={6}>
                  <a
                    className="text-orange text-long-hidden"
                    href={
                      isUnder7 || isUnder20
                        ? safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_5`
                          )?.link_files
                        : safeFiles.find(
                            (f) => f.doc_code === `${row.age_range}_3`
                          )?.link_files
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {isUnder7 || isUnder20
                      ? getImage(row, 5)
                      : getImage(row, 3)}
                  </a>
                </Grid>

                <Grid item xs={4}>
                  <span className="bold">{"สำเร็จ "}</span>
                </Grid>
                <Grid item xs={8}>
                  <span className="text-orange">
                    {normalizeBool(row.cus_check) ? "Y" : "N"}
                  </span>
                </Grid>

                <Grid item xs={4}>
                  <span className="bold">{"แก้ไข "}</span>
                </Grid>
                <Grid item xs={8}>
                  <IconButton
                    onClick={() =>
                      navigate("/benefit-receiving-detail", {
                        state: { id: row.cus_uuid, data: row },
                      })
                    }
                  >
                    <EditRoundedIcon style={{ color: "#FF5E43" }} />
                  </IconButton>
                </Grid>
              </Grid>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

RenderRow.propTypes = {
  row: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  isMobile: PropTypes.bool.isRequired,
};

export const TableBenefitReceiving = ({ data = [], loading = false }) => {
  const isMobile = useMediaQuery("(max-width:480px)");
  const rowPerPage = 10;
  const [page, setPage] = useState(1);

  const handleChange = (_event, value) => setPage(value);

  const firstIndex = (page - 1) * rowPerPage;
  const lastIndex = page * rowPerPage;
  const dataForPage = data.slice(firstIndex, lastIndex);
  const pageCount = data.length > 0 ? Math.ceil(data.length / rowPerPage) : 1;

  // ---------- Loading UI ----------
  if (loading) {
    return (
      <div className="p-4">
        <div className="p-2">
          <Skeleton className="h-70px" />
          {Array.from({ length: 10 }).map((_, i) => (
            <Skeleton key={i} className="h-30px" />
          ))}
        </div>
      </div>
    );
  }

  return (
    <>
      <TableContainer
        className="table-benefit-receiving"
        component={"div"}
        sx={{ backgroundColor: "#F6F6F6CC" }}
      >
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell width={48} align="center">
                No.
              </TableCell>
              <TableCell align="left">ชื่อ</TableCell>
              <TableCell>เลขประจำตัวประชาชน</TableCell>
              {!isMobile ? <TableCell>เบอร์โทร</TableCell> : null}
              <TableCell>ตรวจสอบ</TableCell>
              {!isMobile ? <TableCell>วันที่ลูกค้าทำรายการ</TableCell> : null}
              <TableCell width={40} />
            </TableRow>
          </TableHead>

          <TableBody>
            {data.length > 0 ? (
              dataForPage.map((row, idx) => (
                <RenderRow
                  key={
                    row.id ??
                    row.cus_uuid ??
                    row.policyNo ??
                    `${row.cus_nm}-${row.cus_ln}-${firstIndex + idx}`
                  }
                  index={firstIndex + idx}
                  row={row}
                  isMobile={isMobile}
                />
              ))
            ) : (
              <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                <TableCell
                  align="center"
                  colSpan={isMobile ? 5 : 7}
                  height={120}
                >
                  ไม่พบข้อมูล
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {data.length > 0 && pageCount > 1 && (
        <Pagination
          sx={{ mt: "8px", display: "flex", justifyContent: "end" }}
          count={pageCount}
          variant="outlined"
          shape="rounded"
          size="small"
          showFirstButton
          showLastButton
          hidePrevButton
          hideNextButton
          page={page}
          onChange={handleChange}
          renderItem={(item) => (
            <PaginationItem
              slots={{
                first: KeyboardDoubleArrowLeftRoundedIcon,
                last: KeyboardDoubleArrowRightRoundedIcon,
              }}
              {...item}
            />
          )}
        />
      )}
    </>
  );
};

TableBenefitReceiving.propTypes = {
  data: PropTypes.array.isRequired,
  loading: PropTypes.bool,
};
